import { render } from "./views/DonantDonations.html?vue&type=template&id=756bb1f9&external"
import script from "./DonantDonation.vue?vue&type=script&lang=js"
export * from "./DonantDonation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__